<template>
    <div>
        <button class ="floating-button" @click="goToChatBot">ChatBot</button>
    </div>
</template>

<script>
    export default {
        name: 'ChatBotButton'
    }
</script>

<style>
    .floating-button {
        position: fixed;
        display: inline-flex; 
        align-items: center;
        justify-content: center;
        padding: 10px; 
        height: 65.86px;
        border-radius: 50%; 
        background-color: #08B6AA; 
        color: white; 
        border: none; 
        cursor: pointer; 
        font-size: 11px; 
        text-align: center; 
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        bottom: 100px;
        right: 30px;
        z-index: 10;
    }
</style>
